import React,{  useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import  {useTranslation} from 'react-i18next';
import { Collapse } from 'react-bootstrap';
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons'; 

const WorkHistory = ({ matchedWorkers, matchesConfirmed, resetMatchConfirmation }) => {
    const {t} = useTranslation();
    const [matchChoices, setMatchChoices] = useState([]);
    const [expandHistory, setExpandHistory] = useState(true);
    const [confirmed, setConfirmed] = useState(false);
    const [matchesSelected, setMatchesSelected] = useState(false);
    
    useEffect(() => {
        setMatchChoices(noMatchChoices());
    }, [matchedWorkers])

    const noMatchChoices = () => {

        return matchedWorkers?.reduce((results) => {
            results.push(-1);
            return results;
        }, []);
    }

    const yesMatches = () => {
        return matchChoices?.reduce((results, matchChoice, i) => {

            if (matchChoice)
                results.push(matchedWorkers[i]);

            return results;
        }, []);
    }

    const allMatchesSelected = () => {
        return matchChoices?.reduce((results, matchChoice) => {

            if (matchChoice === -1)
                results = false;

            return results;
        }, true);
    }

    const handleMatchDecision = (workerIdx, value) => {
        matchChoices[workerIdx] = value;
        setMatchesSelected(allMatchesSelected());
    }

    const confirmMatches = () => {
        setConfirmed(true);
        setExpandHistory(false);
        matchesConfirmed(yesMatches());
    }

    const resetMatchChoices = () => {
        setConfirmed(false);
        resetMatchConfirmation();
    };
    
    return (
        <>
        <div className='card p-0 my-3'>
            <h6 className="card-header">
                {t('Work History')}
                { expandHistory 
                    ? <ChevronDown className='float-end' onClick={() => setExpandHistory(false)}/> 
                    : <ChevronUp className='float-end' onClick={() => setExpandHistory(true)}/> 
                }
            </h6>
                    
            <Collapse in={expandHistory}>
                
                <div className='card-body'>
                        
                    <div className='fst-italic fs-6  my-2 py-1'>
                        {t('Work History Statement')}
                    </div>
                            
                    {matchedWorkers?.map((matchedWorker, wIdx) => (
      
                    <div key={`name-div-0-${wIdx}`} className='card my-3 p-0'>

                        <h6 key={`name-div-hdr-${wIdx}`} className="card-header">
                            {matchedWorker.associate.displayName}
                        </h6>    
                        <div key={`name-div-bdy-${wIdx}`} className='card-body'>
            
                            {matchedWorker.assignments?.map((assignment, aIdx) => (

                                <table key={`name-tbl-${wIdx}-${aIdx}`} className='w-100 mb-2'><tbody>
                                    <tr key={`name-tr-0-${wIdx}-${aIdx}`}>
                                    <td key={`name-td-0-0-${wIdx}-${aIdx}`} className='card-title w-50'>
                                        {assignment.project.name}
                                    </td>
                                    <td key={`name-td-0-1-${wIdx}-${aIdx}`} className='card-title w-50'>
                                        <table><tbody>
                                        <tr>
                                            <td key={`name-td-0-2a-${wIdx}-${aIdx}`} className='text-end fw-normal'>{t('Role')}:</td>
                                            <td key={`name-td-0-2b-${wIdx}-${aIdx}`} className='ps-2 fw-bold'>{ assignment.role }</td>
                                        </tr>
                                        </tbody></table>
                                    </td>
                                    </tr>
                                    <tr key={`name-tr-1-${wIdx}-${aIdx}`}>
                                    <td key={`name-td-1-0-${wIdx}-${aIdx}`} className='card-title w-50 text-black-50' >
                                        {assignment.organization.name}
                                    </td>
                                    <td key={`name-td-1-1-${wIdx}-${aIdx}`} className='card-title w-50'>
                                        <table><tbody>
                                        <tr>
                                            <td key={`name-td-1-2a-${wIdx}-${aIdx}`} className='text-end fw-normal'>{t('Craft')}:</td>
                                            <td key={`name-td-1-2b-${wIdx}-${aIdx}`} className='ps-2 fw-bold'>{ assignment.craft }</td>
                                        </tr>
                                        </tbody></table>
                                    </td>
                                    </tr>
                                </tbody></table>
                            ))}

                        </div>
                        <div className='card-footer text-muted' style={{ backgroundColor: '#fff', color: '#dc291a' }}>

                            <Form.Check type={'radio'}>
                                <Form.Check.Input 
                                    name={`name-radio-match-${wIdx}`} 
                                    type={'radio'} 
                                    disabled={confirmed}
                                    onChange={() => handleMatchDecision(wIdx, true)}
                                />
                                <Form.Check.Label className='float-start ms-2 fw-bold'>{t('Yes this is me')}</Form.Check.Label>
                            </Form.Check>
                            <Form.Check type={'radio'}>
                                <Form.Check.Input 
                                    name={`name-radio-match-${wIdx}`} 
                                    type={'radio'} 
                                    disabled={confirmed}
                                    onChange={() => handleMatchDecision(wIdx, false)}
                                />
                                <Form.Check.Label className='float-start ms-2 fw-bold'>{t('No this is not me')}</Form.Check.Label>
                            </Form.Check>

                        </div> 

                    </div>                           

                    ))}
                    { confirmed 
                        ? <div className='fw-bold'>
                            {t('Confirmed')}
                            <button type="button" className='float-end' style={{ color: '#fff', backgroundColor: '#dc291a' }} onClick={ () => resetMatchChoices() }>{t('Reset')}</button>
                          </div>
                        : matchesSelected 
                            ? <button type="button" style={{ color: '#fff', backgroundColor: '#dc291a' }} onClick={ () => confirmMatches() }>{t('Confirm')}</button>
                            : <></>
                    }
                        
                </div>

            </Collapse>

        </div>
        </>
    )
}

export default WorkHistory;